import { ResourceArticle } from '../types';
import { ARTICLES_PART_1 } from './articles/part1';
import { ARTICLES_PART_2 } from './articles/part2';
import { ARTICLES_PART_3 } from './articles/part3';
import { ARTICLES_PART_4 } from './articles/part4';
import { ARTICLES_PART_5 } from './articles/part5';
import { ARTICLES_PART_6 } from './articles/part6';
import { ARTICLES_PART_7 } from './articles/part7';

export const RESOURCE_ARTICLES: ResourceArticle[] = [
  ...ARTICLES_PART_1,
  ...ARTICLES_PART_2,
  ...ARTICLES_PART_3,
  ...ARTICLES_PART_4,
  ...ARTICLES_PART_5,
  ...ARTICLES_PART_6,
  ...ARTICLES_PART_7
];
